import mapSimpleCategory from './mapSimpleCategory';

const mobileLivingRoomData = mapSimpleCategory({
  categoryTitle: 'Living Room',
  subcategories: [
    {
      subcategoryTitle: 'Sofas and Sectionals',
      link: '/sofas-and-sectionals',
      imageUrl:
        'https://joybird2.imgix.net/configurations/pid_571/-CF347-WS03/571-CF347-WS03-eliot-sofa-sunbrella-premier-fog-t1-1_t.png',
    },
    {
      subcategoryTitle: 'Loveseats',
      link: '/loveseats',
      imageUrl:
        'https://joybird2.imgix.net/configurations/pid_1009/-CF033-WS03/1009-CF033-WS03-hughes-loveseat-bentley-daisey-t1-1_t.png',
    },
    {
      subcategoryTitle: 'Accent Chairs',
      link: '/accent-chairs',
      imageUrl:
        'https://joybird2.imgix.net/configurations/pid_550/-CF200-W03/550-CF200-W03-collins-chair-taylor-felt-grey-t1-2_t.png',
    },
    {
      subcategoryTitle: 'Ottomans & Benches',
      link: '/ottomans',
      imageUrl:
        'https://joybird2.imgix.net/product_hero/9302/-CL037/9302-CL037-lyle-leather-ottoman-colonade-sycamore-t1-2_ts.png',
    },
    {
      subcategoryTitle: 'End & Entry Tables',
      link: '/end-tables-entry-tables',
      imageUrl:
        'https://joybird2.imgix.net/product_hero/9359/9359-marlow-end-table-t1-1_ts.png',
    },
    {
      subcategoryTitle: 'Media Consoles',
      link: '/media-consoles',
      imageUrl:
        'https://joybird2.imgix.net/product_hero/9273/9273-butler-small-console-t1-1_ts.png',
    },
    {
      subcategoryTitle: 'Bookcases & Shelving',
      link: '/bookcases-wall-units',
      imageUrl:
        'https://joybird2.imgix.net/product_hero/9807/9807-lois-bookcase-with-storage-t1-2_ts.png',
    },
    {
      subcategoryTitle: 'Bar Carts & Cabinets',
      link: '/bar-carts-cabinets',
      imageUrl:
        'https://joybird2.imgix.net/product_hero/9791/9791-piper-cabinet-t1-1_ts.png',
    },
    {
      subcategoryTitle: 'All Living Room Furniture',
      link: '/living-room-furniture',
      imageUrl:
        'https://joybird2.imgix.net/configurations/pid_1054/-CL044-WS03/1054-CL044-WS03-eliot-leather-sofa-santiago-camel-t1-1_t.png',
    },
  ],
});

export default mobileLivingRoomData;
